import { render, staticRenderFns } from "./Starred.vue?vue&type=template&id=187895b8&scoped=true"
import script from "./Starred.vue?vue&type=script&lang=js"
export * from "./Starred.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187895b8",
  null
  
)

export default component.exports